import { useSelector } from "react-redux"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { API_BANKS_PERMISSION_URL } from "../constants"
import { RootState } from "../../store/store"
import { IErrorResponse } from "../interface"
import { GET_PERMISSIONS_BANK_LIST_QUERY_KEY } from "./usePermissionBankList"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

const addBankPermission = async (bankId: string, token: string | null) => {
  const response = await axios(`${API_BANKS_PERMISSION_URL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: {
      bankId,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при запросе данных: ${response.status} - ${response.statusText}`,
    )
  }
}

export const useAddBankPermission = () => {
  const token = useSelector((state: RootState) => state.auth.token)
  const queryClient = useQueryClient()

  return useMutation<null, IErrorResponse, string>({
    mutationFn: async (bankId: string) => {
      await addBankPermission(bankId, token)
      await queryClient.invalidateQueries({
        queryKey: [GET_PERMISSIONS_BANK_LIST_QUERY_KEY],
      })
      return null
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PERMISSIONS_BANK_LIST_QUERY_KEY],
      })
    },
  })
}
